import { useMemo } from 'react';
import { useLazyQuery } from './../index';
import { GET_USER_ORGANIZATIONS } from './useQueryUserOrganizations';

export default () => {
  const [getUserOrganizations, { data, loading, error, called }] = useLazyQuery(GET_USER_ORGANIZATIONS, {});

  const transformedData = useMemo(() => {
    return !data?.auth0_user_orgs ? [] : data.auth0_user_orgs.organizations;
  }, [data]);

  return [
    getUserOrganizations,
    {
      data: transformedData,
      loading,
      done: called && !loading, // ChatGPT said this was how to determine the "done" state
      error,
    },
  ];
};
